<template>
    <div class="mb-5 flex w-full group cursor-pointer video-card">
           <div class="video-thumb h-[200px] sm:h-[150px] lg:w-[200px] w-[150px] " :style="`background:url(${video.image})`">
           <div class="h-[200px] sm:h-[150px] lg:w-[200px] w-[150px]  bg-[#0008] opacity-0 group-hover:opacity-100 transition-all duration-150 flex justify-center items-center"><img src="/static/images/icons/play.svg" class="w-12 h-12" alt="play"></div>
           </div>
           <div class="border-b ltr:ml-4 rtl:mr-4 w-full  lg:text-lg text-base   flex flex-col justify-center" >
            <div class="truncate w-6/12 md:w-8/12 al-bold">   {{video.title}}</div>
               <div class="pt-10 w-max">{{video.year}}</div>
           </div>
    </div>
</template>
<script>
export default {
    props:['video']
}
</script>